// extracted by mini-css-extract-plugin
export var bimIframe = "index-module--bim-iframe--750db";
export var iframeWrapper = "index-module--iframe-wrapper--ed5f1";
export var partsArenaIframe = "index-module--parts-arena-iframe--2caef";